import { render, staticRenderFns } from "./StatusTitle.vue?vue&type=template&id=f30fe87e&"
import script from "./StatusTitle.vue?vue&type=script&lang=js&"
export * from "./StatusTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports